import React, { useState, useCallback, useEffect, useContext, useRef, useMemo } from 'react';
import Head from 'next/head';
import get from 'lodash/get';
import filter from 'lodash/filter';
import Router, { useRouter } from 'next/router';
import CSSTransition from 'react-transition-group/CSSTransition';
import Cookies from 'cookies';

import isEmpty from 'lodash/isEmpty';
import getDefaultTab from '../../helpers/getDefaultTab';
import AddressBox from '../../components/AddressBox';
import Header from '../../components/Header';
import FreightLimit from '../../components/FreightLimit';
import DangerousHTML from '../../components/DangerousHTML';
import CategoriesSkeleton from '../../components/DTC/CategorySkeleton';
import CategoryMenu from '../../components/DTC/CategoryMenu';
import { brand } from '../../constants/breadcrumbPaths';
import notificationTypes from '../../constants/modalNotificationConst';

import * as COOKIE_VARIABLES from '../../constants/cookieVariables';
import { ASAP, SCHEDULE, ASAP_AND_SCHEDULE } from '../../constants/deliveryType';
import { DEFAULT_CATEGORY_MENU, DEFAULT_LOCATION, DEFAULT_ZIPCODE } from '../../constants/default';
import * as WEBSITES from '../../constants/website';

import HraderDeliveryAddress from '../../components/HraderDeliveryAddress';
import RemainingTime from '../../components/RemainingTime';
import Page404 from '../404';
import DeliveryTabs from '../../components/DTC/DeliveryTabs';
import Filter from '../../components/DTC/Filter';
import generateFilters from '../../helpers/generateFilters';
import categoriesHelper from '../../helpers/categoriesHelper';

import axios from '../../utils/ajax';

import { useBrand, useBannerImages, useFullCategoryList, useFilters } from '../../hooks/Shop';
import { useDeliveryDetails } from '../../hooks/app';
// import appConfig from '../../appConfig';
import oldBrandSlug from '../../constants/oldBrandSlug';
import newBrandSlug from '../../constants/newBrandSlug';
import useSegment from '../../hooks/segment';
import appContext from '../../Context/appContext';
import Banner from '../../components/BannerNew';
import SelectedFiltersList from '../../components/SelectedFiltersList';
import BreadCrumbs from '../../components/BreadCrumbs';
import FloatingFilterButton from '../../components/FloatingFilterButton';
import grassdoorRedirects from '../../constants/grassdoorRedirects';
import getHost from '../../helpers/gethost';
import { matchFilter } from '../../helpers/filterHelper';
import MiniTabs from '../../components/DTC/grassdoor/MiniTabs';
import DesktopFilter from '../../components/DesktopFilter';
import isMobile from '../../helpers/isMobile';
import FloatingCompareButton from '../../components/FloatingCompareButton';
import { ALLOW_PRODUCT_COMPARE } from '../../constants/verificationConst';
import { getFaqSchema } from '../../helpers/getFaqSchema';
import bentoRedirects from '../../constants/bentoRedirects';
import InlineLoader from '../../components/InlineLoader';
import pageDisable from '../../helpers/pageDisableHelper';
import { useScrollTop } from '../../hooks/scroll';
import FixedBottomBar from '../../components/FixedBottomBar';
import SearchTabs from '../../components/DTC/grassdoor/SearchTabs';
import { isNewHomePageApplicable } from '../../constants/feature';
import SearchButton from '../../components/searchModule/SearchButton';
import { convertSlugToLowerCase } from '../../helpers/handleCases';
import { BannerSlider } from '../../components/BannerSlider';
import NoProductAvailable from '../../components/no-products-available';
import Product from '../../components/Product';
import GrassdoorSecondaryBanners from '../../components/DTC/grassdoor/GrassdoorSecondaryBanners';
import BrandMenu from '../../components/DTC/grassdoor/BrandMenu';
import ReferralAndFnFBannerData from '../../constants/ReferralAndFnFBannerData';
import { useDispatch, useSelector } from 'react-redux';
import { increaseURLstack, pushIfNotPresent } from '../../redux/slices/modalSlice';
import { setUrlBeforeCompare, updateSelectedTab } from '../../redux/slices/userSlice';
import DeliveryTypeToggle from '../../components/DeliveryTypeToggle';
import HraderDeliveryAddressNew from '../../components/DTC/bento/HraderDeliveryAddress'
import ScrollToTop from '../../components/ScrollToTop';
import { withConfig } from '../../lib/withConfig';
import { useConfigData } from '../../Context/ConfigProvider';
import fetchServerResponse from '../../helpers/serverHelper';
import BannerCustom from '../../components/BannerCustom';
import DeliveryTiming from '../../components/DeliveryTiming';
import DeliveryTimingSchedule from '../../components/DeliveryTimingSchedule';

const canonicalHref = `https://${getHost()}/brands/`; //same used for og:url

const Brand = ({
  brandData: initialBrandData,
  filterList,
  error,
  bannerData,
  host,
  noIndex,
  fullCategoriesList: initialFullCategoriesList,
  id,
  topBrands,
  hideFreightLimit
}) => {
  const {
    state: {
      // initialHistoryLength,
      shop: { brandsFilters },
      // user: { userSelectedTab },
      // miniTabs,
      // compare,
      // searchTabs
    },
    dispatch
  } = useContext(appContext);
  const miniTabs = useSelector(state => state.other.miniTabs)
  const compare = useSelector(state => state.compare)
  const { userSelectedTab, searchTabs, initialHistoryLength } = useSelector(state => state.user)
  const dispatchRedux = useDispatch()
  const router = useRouter();
  const appConfig = useConfigData();
  const {
    data: { asapEnabled = true, scheduleEnabled, lastSlotCutOff, asapEndTime, asapStartTime },
    isLoading: isAddressLoading
  } = useDeliveryDetails();

  const {
    query: { slug, tab: routerTab }
  } = router;

  const tab = routerTab || getDefaultTab({ lastSlotCutOff, asapEndTime, asapStartTime, asapEnabled });

  const { data: filterBrandList = [], isValidating: isValidatingFilters } = useFilters({ param: 'brand_slug', slug });

  const [isFilterPopupVisible, toggleFilterPopup] = useState(false);
  const [isSolid, setSolid] = useState(false);
  const [filters, setFilters] = useState(filterBrandList || brandsFilters || filterList);
  const { data: fullCategoryList = DEFAULT_CATEGORY_MENU } = useFullCategoryList({ initialFullCategoriesList });
  const handleScroll = useCallback(() => {
    if (window.scrollY > 150) {
      if (!isSolid) {
        setSolid(true);
      }
    } else if (isSolid) {
      setSolid(false);
    }
  }, [isSolid]);

  useEffect(() => {
    if (!isValidatingFilters && filters && filterBrandList) {
      const newFilters = matchFilter(filters, filterBrandList);
      setFilters(newFilters);
    }
  }, [isValidatingFilters]);

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  let currentTab = tab;
  if (!asapEnabled) {
    currentTab = SCHEDULE;
  } else if (!scheduleEnabled) {
    currentTab = ASAP;
  }

  let bothTypeSchedule = false;
  if (scheduleEnabled && asapEnabled) {
    bothTypeSchedule = true;
  }

  const pathName = routerTab || getDefaultTab({ lastSlotCutOff, asapEndTime, asapStartTime });
  useEffect(() => {
    if (currentTab == ASAP && pathName == SCHEDULE && !bothTypeSchedule && !isAddressLoading) {
      router.push(`/brands/${slug}?tab=${ASAP}`);
    } else if (currentTab == SCHEDULE && pathName == ASAP && !bothTypeSchedule && !isAddressLoading) {
      router.push(`/brands/${slug}?tab=${SCHEDULE}`);
    }
  }, [pathName, currentTab, bothTypeSchedule, isAddressLoading]);

  const { data, isLoading, isValidating, modifyCount } = useBrand({ slug, initialBrandData, filters });

  const brandData = useMemo(() => {
    if (!data || !data.brandData || isEmpty(data.brandData)) return initialBrandData || {};
    return data.brandData || {};
  }, [data]);

  // const asapCount = brandData?.asap_categories
  //   ? brandData.asap_categories.reduce((total, category) => {
  //     const productCount = category && category.products && category.products.length ? category.products.length : 0;
  //     return total + productCount;
  //   }, 0)
  //   : null;

  // const scheduleCount = brandData?.schedule_categories
  //   ? brandData.schedule_categories.reduce((total, category) => {
  //     const productCount = category && category.products && category.products.length ? category.products.length : 0;
  //     return total + productCount;
  //   }, 0)
  //   : null;

  const { asapProductsID = [], asapBundleID = [] } = useMemo(() => {
    const asapProductsID = [];
    const asapBundleID = [];
    brandData?.asap_categories?.forEach(categories => {
      if (process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR || process.env.NEXT_PUBLIC_DEFAULT_SITES) {
        if (categories.product_details_id) {
          asapProductsID.push(categories.product_details_id);
        }
        if (categories.bundle_id) {
          asapBundleID.push(categories.bundle_id);
        }
      } else {
        categories.products.forEach(product => {
          if (product.product_details_id) {
            asapProductsID.push(product.product_details_id);
          }
          if (product.bundle_id) {
            asapBundleID.push(product.bundle_id);
          }
        });
      }
    });
    return { asapProductsID, asapBundleID };
  }, [brandData]);

  const { scheduleProductsID = [], scheduleBundleID = [] } = useMemo(() => {
    const scheduleProductsID = [];
    const scheduleBundleID = [];
    brandData?.schedule_categories?.forEach(categories => {
      if (process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR || process.env.NEXT_PUBLIC_DEFAULT_SITES) {
        if (categories.product_details_id) {
          scheduleProductsID.push(categories.product_details_id);
        }
        if (categories.bundle_id) {
          scheduleBundleID.push(categories.bundle_id);
        }
      } else {
        categories.products.forEach(product => {
          if (product.product_details_id) {
            scheduleProductsID.push(product.product_details_id);
          }
          if (product.bundle_id) {
            scheduleBundleID.push(product.bundle_id);
          }
        });
      }

    });
    return { scheduleProductsID, scheduleBundleID };
  }, [brandData]);

  const asapCount = useMemo(() => {
    if (isLoading) return null;
    if (modifyCount) return new Set(asapProductsID).size + new Set(asapBundleID).size;
    return 0;
  }, [modifyCount, asapProductsID, asapBundleID, isLoading]);

  const scheduleCount = useMemo(() => {
    if (isLoading) return null;
    if (modifyCount) return new Set(scheduleProductsID).size + new Set(scheduleBundleID).size;
    return 0;
  }, [modifyCount, scheduleProductsID, scheduleBundleID, isLoading]);

  // const scheduleCount = brandData.schedule_categories
  //   ? brandData.schedule_categories.reduce((total, category) => {
  //     const productCount = category && category.products && category.products.length ? category.products.length : 0;
  //     return total + productCount;
  //   }, 0)
  //   : null;

  const bannerOgImage = brandData && brandData.banner_images ? brandData.banner_images : {};

  const ogImage = bannerOgImage?.[currentTab]?.primary?.[0]?.desktop_image_url || brandData?.og_image || appConfig.META_IMAGE;

  const {
    brand_meta_title: brandMetaTitle,
    brand_meta_description: brandMetaDescription,
    og_title: ogTitle,
    og_description: ogDescription
  } = brandData;

  const setTab = useCallback(
    newTab => {
      if (tab !== newTab) {
        const href = `/brands/${slug}?tab=${newTab}`;
        // const as = '/brands/[slug]';
        router.replace(href, undefined, { shallow: true });
      }
    },
    [tab, router, slug]
  );

  const { trackPage } = useSegment();
  // Segment Data Layer
  useEffect(() => {
    if (brandData) {
      trackPage('Brand Page');
    }
  }, []);

  useEffect(() => {
    dispatch({ type: 'setFilters', payload: { brandsFilters: filters } });
  }, [filters]);

  if (error || appConfig.hideBrandPage) {
    return (
      <>
        <Page404 showNavbar hideTabsInError asapProductsCount={asapCount} scheduledProductsCount={scheduleCount} />
      </>
    );
  }

  const handleFloatingButtonClick = () => {
    const url = '/compare';
    dispatchRedux(pushIfNotPresent({ type: notificationTypes.comparePopup, data: { source: "Floating widget" } }))
    dispatchRedux(increaseURLstack())
    // dispatch({ type: 'setUrlBeforeCompare', payload: { urlBeforeCompare: window.location.href } });
    dispatchRedux(setUrlBeforeCompare({ urlBeforeCompare: window.location.href }))
    window.history.replaceState({ ...window.history.state, as: url, url }, '', url);
  };

  let filterApplied = false;
  if (filters) {
    filters.forEach(element => {
      if (
        element.type === 'sort_key' &&
        (!element.values[0].checked || (element.values[0].checked && element.values[0]?.intended))
      ) {
        filterApplied = true;
      }
      if (element.type === 'search' && filter(element.values, { checked: true }).length > 0) {
        filterApplied = true;
      }
    });
  }

  function renderSchema() {
    const productList =
      brandData.schedule_categories && brandData.schedule_categories.length ? brandData.schedule_categories : [];

    const productListObj = [];

    productList?.length && productList.forEach((product, key) => {
      productListObj.push({
        '@type': 'ListItem',
        position: key + 1,
        url: `https://${host}/${product.slug}`
      });
    });

    const schemaObject = {
      '@context': 'https://schema.org/',
      '@type': 'CollectionPage',
      '@id': `${`https://${host}`}/brands/${brandData.brand_slug}`,
      name: brandData.brand_name,
      url: `${`https://${host}`}/brands/${brandData.brand_slug}`,
      description: brandData.brand_description,
      image:
        brandData.banner_images && brandData.banner_images.asap.length
          ? brandData.banner_images.asap.primary[0].desktop_image_url
          : '',
      publisher: {
        '@type': 'Organization',
        name: appConfig.APP_NAME,
        logo: {
          '@type': 'ImageObject',
          url: appConfig.HEADER_LOGO_COLOR
        }
      },
      keywords: [brandData.brand_name, brandData.brand_meta_title],
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: productListObj
      },
      subjectof: {
        '@type': 'Brand',
        name: brandData.brand_name
      }
    };

    const scriptArray = [
      <script key="FE_schema" type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaObject) }} />
    ];

    if (brandData?.schema) {
      scriptArray.push(
        <script key="API_schema" type="application/ld+json" dangerouslySetInnerHTML={{ __html: brandData.schema }} />
      );
    }

    return scriptArray;
  }

  function renderBreadCrumbSchema() {
    const breadCrumbsListObject = [
      {
        '@context': 'https://schema.org/',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: `https://${host}/`
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'Brands',
            item: `${`https://${host}`}/brands`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: `${brandData.brand_name}`,
            item: `${`https://${host}`}/brands/${brandData.brand_slug}`
          }
        ]
      }
    ];
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadCrumbsListObject) }} />;
  }

  const [listLoading, setListLoading] = useState(false);
  const fetching = isValidating || isLoading;

  useEffect(() => {
    const filters = [...filterList];
    const tempFilters = filters.map(item => {
      const filter = { ...item };

      filter.values = filter.values.map((subItem, index) => {
        let optionValue = { ...subItem };
        if (optionValue.type === 'checkbox') {
          optionValue.checked = false;
        } else if (optionValue.type === 'radio') {
          delete optionValue.intended;
          optionValue.checked = index === 0;
        } else {
          optionValue = optionValue;
        }
        return optionValue;
      });
      return filter;
    });
    setFilters(tempFilters);
  }, [slug]);

  return (
    <>
      <Head>
        {renderSchema()}

        {renderBreadCrumbSchema()}

        {[WEBSITES.GRASSDOOR, WEBSITES.BENTO].includes(process.env.NEXT_PUBLIC_APP) && brandData?.brand_faqs?.length ? (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: getFaqSchema(brandData.brand_faqs)
              })
            }}
          />
        ) : null}

        <meta charSet="utf-8" name="robots" />
        <title>{brandMetaTitle}</title>
        <meta name="description" content={brandMetaDescription} />
        {noIndex && <meta name="robots" content="noindex" />}
        <meta property="og:title" content={ogTitle || appConfig.META_TITLE} />
        <meta property="og:description" content={ogDescription || appConfig.META_TITLE_DESCRIPTION} />
        <meta property="og:image" content={ogImage || appConfig.META_IMAGE} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${canonicalHref}${convertSlugToLowerCase(id)}`} />
        <link rel="canonical" href={`${canonicalHref}${convertSlugToLowerCase(id)}`} />
      </Head>
      <Header
        hasShadow={isSolid}
        hasWhiteBg={isSolid}
        centerComponent={<HraderDeliveryAddress hideOnLarge />}
        onClickFilter={() => toggleFilterPopup(true)}
        showFilter={!isNewHomePageApplicable}
        filterApplied={filterApplied}
        currentTab={tab}
        asapProductsCount={asapCount || 0}
        scheduledProductsCount={scheduleCount || 0}
        setTab={setTab}
        showUserInfo={isNewHomePageApplicable}
        showDeliverySpecificMessage={isNewHomePageApplicable}
        showLogin={!isNewHomePageApplicable}
        showProfile
        help={isNewHomePageApplicable}
        showHappyHours
      />
      {
        isNewHomePageApplicable ?
          <SearchTabs
            enabled={false}
            fullCategoryList={fullCategoryList}
            defaultSearchTab="schedule"
            currentTab={tab}
            setTab={setTab}
          >
            <SelectedFiltersList filtersList={filters} filtersType="shopFilter" />
          </SearchTabs>
          :
          <MiniTabs
            enabled={miniTabs}
            fullCategoryList={fullCategoryList}
            currentTab={tab}
            asapProductsCount={asapCount}
            scheduledProductsCount={scheduleCount}
            asapEnabled={asapEnabled}
            scheduleEnabled={scheduleEnabled}
            setTab={setTab}
            className="category-page-tabs"
          >
            <SelectedFiltersList filtersList={filters} filtersType="shopFilter" />
          </MiniTabs>
      }

      <BrandContent
        brandData={brandData}
        asapCount={asapCount}
        scheduleCount={scheduleCount}
        tab={tab}
        isLoading={isLoading}
        isValidating={isValidating}
        setTab={setTab}
        filters={filters}
        filterList={filterList}
        toggleFilterPopup={toggleFilterPopup}
        setFilters={setFilters}
        fullCategoryList={fullCategoryList}
        filterApplied={filterApplied}
        bannerData={bannerData}
        modifyCount={modifyCount}
        isSolid={isSolid}
        compare={compare}
        handleFloatingButtonClick={handleFloatingButtonClick}
        topBrands={topBrands}
        listLoading={listLoading}
        setListLoading={setListLoading}
        hideFreightLimit={hideFreightLimit}
        key={tab}
      />

      {isNewHomePageApplicable ? (
        <ScrollToTop />
      ) : null}

      <button
        onClick={() => toggleFilterPopup(true)}
        className={`scroll-to-top filter`}
      >
        <span className="icon icon-filter-dark-i text-[12px]" />
      </button>
      <div style={{ position: 'relative' }}>
        <div
          id="bottomDivBrand"
          style={{ height: 400, width: '100%', position: 'absolute', bottom: 0, opacity: 0.5, zIndex: -100 }}
        />
      </div>
      <CSSTransition appear in={isFilterPopupVisible} mountOnEnter timeout={300} classNames="slideup-wrapper" unmountOnExit>
        <Filter
          currentTab={tab}
          isFilterPopupVisible={isFilterPopupVisible}
          filterList={filters}
          applyFilters={filters => {
            setListLoading(true);
            if (filters) {
              setFilters(filters);
            } else {
              // toggleFilterPopup(false);
              setFilters(filterList);
            }
            if (!fetching) setListLoading(false);
          }}
          cancelFilters={() => toggleFilterPopup(false)}
          deviceType="mobile"
          asapProductsCount={asapCount}
          scheduledProductsCount={scheduleCount}
          isPopup
          isFilterApplied={filterApplied}
        />
      </CSSTransition>
    </>
  );
};

const BrandContent = ({
  brandData,
  tab,
  setTab,
  isLoading,
  isValidating,
  filters,
  filterList,
  toggleFilterPopup,
  setFilters,
  filterApplied,
  bannerData: initialBannerData,
  fullCategoryList,
  modifyCount,
  isSolid,
  compare,
  handleFloatingButtonClick,
  topBrands,
  listLoading = false,
  asapCount,
  scheduleCount,
  setListLoading = () => { },
  hideFreightLimit,
  initialDeliveryAddressDetails,
  hideFilters
}) => {
  const {
    brand_name: brandName = '',
    brand_description: brandDescription,
    short_description: shortDescription,
    asap_categories: asapCategories = [],
    schedule_categories: scheduleCategories = [],
    brand_faqs: brandFaqs = [],
    h1_tag: h1Tag = ''
  } = brandData;
  const appConfig = useConfigData();
  const {
    data: { asapEnabled = true, scheduleEnabled, unified_menu: unifiedMenu }
  } = useDeliveryDetails();
  const { data: bannerData } = useBannerImages({ initialBannerData });
  const [displayFreightBanner, setDisplayFreightBanner] = useState(true)
  const brandDescriptionRef = useRef();
  const { scrollDirectionTop } = useScrollTop()

  const currentCategory = tab === ASAP ? asapCategories : scheduleCategories;

  const fetching = isValidating || isLoading;

  const customBanner = brandData.banner_images || {};

  const setTrack = (c, y) => {
    // console.log('settrack', c, y)
  };

  let breadcrumbPath = [
    ...brand,
    ...[
      {
        icon: '',
        title: brandName,
        path: ''
      }
    ]
  ];

  breadcrumbPath = ![WEBSITES.GRASSDOOR, WEBSITES.BENTO, WEBSITES.GANJAGODDESS].includes(process.env.NEXT_PUBLIC_APP)
    ? breadcrumbPath.filter(item => item.title !== 'Brands')
    : breadcrumbPath;

  useEffect(() => {
    if (!fetching) {
      setTimeout(() => setListLoading(false), 1000);
    }
  }, [filters, fetching]);

  const name = h1Tag || brandName || '';

  function renderProducts(productDetails, currentTab, currentCategoryName) {
    if (productDetails) {
      return productDetails.map((item, productIndex) => {
        return (
          <Product
            page={`${currentTab == SCHEDULE ? 'Schedule' : 'ASAP'} List-${item.category_name}`}
            productIndex={productIndex}
            categoryIndex={0}
            width50
            data={item}
            openInPopup
          />
        );
      });
    }
    return null;
  }

  return (
    <div className="brands category-product shop-full-menu">
      <div className='mobile-toggle px-2'>
        <div>
          <div className='flex justify-center w-full items-center gap-4'>
            <div id="search-category-wrapper" className={`search-category-wrapper mt-2 flex-grow max-w-[780px]`}>
              <div className={`searchBox`}>
                <div className="new-search-component">
                  <div className="input-group searchBar">
                    <div className="input-group searchBar">
                      <HraderDeliveryAddressNew />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DeliveryTypeToggle
          currentTab={tab}
          setTab={setTab}
          isAsapDisabled={false}
          isScheduleDisabled={!scheduleEnabled}
          hideToggle={!asapEnabled || !scheduleEnabled}
          displayForMobile
        />

        <div className='text-center block md:hidden  mt-[12px] md:mt-0'>
          {
            tab === ASAP ?
              <DeliveryTiming currentTab={"asap"} onlyText fullText />
              :
              <DeliveryTimingSchedule onlyText currentTab={tab} fullText />
          }
        </div>
      </div>
      {fullCategoryList && <CategoryMenu fullCategoryList={fullCategoryList} />}
      <BannerCustom bannerData={bannerData} currentTab={tab} />

      {
        isNewHomePageApplicable ?
          <SearchButton toggleFilterPopup={toggleFilterPopup} hideFilter />
          :
          null
      }
      {/* short description design needs to be handled */}
      <div className="brands-desc-wrapper">
        <div className={`container-lg pb-lg-0 ${isNewHomePageApplicable ? 'brand-wrap' : 'dtc-container p-lg-4 p-3'}`}>
          <div className="row align-items-center">
            <div className={shortDescription && false ? 'col-lg-6 p-0 p-lg-2 desc-pd' : 'col-lg-12 p-0 p-lg-2 desc-pd'}>
              {/* {
                isNewHomePageApplicable ?
                  <BannerSlider customBanner={customBanner} bannerData={bannerData} />
                  :
                  (
                    <Banner customBanner={customBanner} bannerData={bannerData} loading={!listLoading && isLoading}>
                      <AddressBox />
                    </Banner>
                  )} */}
            </div>
            {/* <div className={`container short-description mt-3 mt-lg-0 ${shortDescription && false ? 'col-lg-6' : 'col-lg-12'}`}>
              {shortDescription && false ? (
                <p>
                  <DangerousHTML html={shortDescription} />
                </p>
              ) : null}

              <p className={` mb-0 ${shortDescription && false ? '' : 'text-lg-right'}`}>
                <a
                  className="mt-3 brand-more-link"
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    brandDescriptionRef.current?.scrollIntoView();
                    setTimeout(() => {
                      brandDescriptionRef.current?.scrollIntoView();
                    }, 60);
                  }}
                >
                  {`Read More About ${brandName}`}
                </a>
              </p>
            </div> */}
          </div>
        </div>
      </div>

      <div className="container">
        <div className="filter-product-page">
          <div className="g-right-sec">
            <div className="">
              <div className=" four-rem-mb mt-lg-3">
                <>
                  {
                    isNewHomePageApplicable ?
                      null
                      :
                      <>
                        <DeliveryTabs
                          asapProductsCount={asapCount}
                          scheduledProductsCount={scheduleCount}
                          asapEnabled={asapEnabled}
                          scheduleEnabled={scheduleEnabled}
                          currentTab={tab}
                          className="category-page-tabs "
                          setTab={setTab}
                        />

                        <FreightLimit currentTab={tab} />
                        <RemainingTime setTab={setTab} currentTab={tab} />
                      </>
                  }
                  <div className="text-center">
                    {filters && filters.length > 0 ? (
                      <div
                        className={
                          appConfig.isGrassdoor
                            ? 'sidebarItemStyle filter-btn dig-bud my-4 d-none'
                            : 'sidebarItemStyle ml-2 filter-btn fab d-lg-none hide-for-kiva d-none'
                        }
                        role="presentation"
                        onClick={() => toggleFilterPopup(true)}
                      >
                        <span className="icon icon-filter" />
                        <span className="text">
                          &nbsp;
                          {appConfig.isGrassdoor ? 'FILTER AND SORT' : 'Filters'}
                        </span>
                        {filterApplied && <span className="filter-indicator" />}
                      </div>
                    ) : null}
                  </div>
                  {
                    isMobile() ?
                      isNewHomePageApplicable ? null :
                        (
                          <FloatingFilterButton
                            filters={filters}
                            toggleFilterPopup={toggleFilterPopup}
                            filterApplied={filterApplied}
                            isSolid={isSolid}
                          />
                        )
                      :
                      <DesktopFilter
                        filterList={filters}
                        currentTab={tab}
                        applyFilters={filters => {
                          setListLoading(true);
                          if (!filters) {
                            setFilters(filterList);
                          } else {
                            setFilters(filters);
                          }
                          // if (!fetching) setListLoading(false);
                        }}
                        cancelFilters={() => toggleFilterPopup(true)}
                        deviceType="desktop"
                        isFilterApplied={filterApplied}
                        shadowHeight={750}
                      >
                        <SelectedFiltersList setListLoading={setListLoading} filtersList={filters} filtersType="shopFilter" className="sticky-filter-list" />
                      </DesktopFilter>
                  }
                  {/* ) : null} */}

                  {isNewHomePageApplicable ? null : <SelectedFiltersList
                    setListLoading={setListLoading}
                    filtersList={filters}
                    filtersType="brandFilter"
                    className="d-lg-none"
                  />}

                  <div className=" ">
                    <h1 className="bold h3 b-title mt-4 mt-lg-5" style={{ visibility: !name ? 'hidden' : '' }}>
                      {name || '_'}
                      {process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR || process.env.NEXT_PUBLIC_APP === WEBSITES.BENTO
                        ? ' Delivery Near me'
                        : ''}
                    </h1>
                  </div>
                  {/* Do not remove */}
                  <div id="list-top" />

                  {isNewHomePageApplicable ? null : <BreadCrumbs paths={breadcrumbPath} />}

                  {
                    listLoading && (
                      <div className="text-center my-3">
                        <InlineLoader positionRelative className="big" />
                      </div>
                    )
                  }

                  <div style={{ minHeight: listLoading && '100vh' }}>
                    {
                      process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR ||
                        process.env.NEXT_PUBLIC_DEFAULT_SITES ?
                        <div className="four-rem-mb four-rem-pb zipps-see-all">
                          {currentCategory?.length ? (
                            <div>
                              <div
                                className={`v-list product-category mt-2`}
                              >
                                {renderProducts(currentCategory, tab, currentCategory.category_name)}
                              </div>
                            </div>
                          ) : (
                            <>
                              {!listLoading && (
                                <div className="one-rem-mt four-rem-mb">
                                  {/* <ItemNotFound text="No products found" /> */}
                                  <NoProductAvailable
                                    currentTab={tab}
                                    asapProductsCount={asapCount}
                                    scheduledProductsCount={scheduleCount}
                                    setTab={setTab}
                                    asapEnabled={asapEnabled}
                                    scheduleEnabled={scheduleEnabled}
                                    setTrack={setTrack}
                                    applyFilters={filters => {
                                      setListLoading(true);
                                      if (!filters) {
                                        setFilters(filterList);
                                      } else {
                                        setFilters(filters);
                                      }
                                      // if (!fetching) setListLoading(false);
                                    }}
                                  />
                                </div>
                              )}
                            </>
                          )}
                        </div>
                        :
                        <CategoriesSkeleton
                          asapProductsCount={asapCount}
                          scheduledProductsCount={scheduleCount}
                          setTrack={setTrack}
                          setTab={setTab}
                          categories={tab === ASAP ? asapCategories : scheduleCategories}
                          currentTab={tab}
                          fetching={fetching || listLoading}
                          asapEnabled={asapEnabled}
                          scheduleEnabled={scheduleEnabled}
                          topBrands={topBrands}
                          applyFilters={filters => {
                            setListLoading(true);
                            if (!filters) {
                              setFilters(filterList);
                            } else {
                              setFilters(filters);
                            }
                            // if (!fetching) setListLoading(false);
                          }}
                          showViewAll={false}
                        />
                    }
                  </div>
                  {ALLOW_PRODUCT_COMPARE ? (
                    <FloatingCompareButton
                      isSolid={isSolid}
                      products={compare?.productList || []}
                      handleOnClick={() => {
                        handleFloatingButtonClick();
                      }}
                    />
                  ) : null}
                </>
              </div >

              {process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR && (
                <GrassdoorSecondaryBanners secondaryBannerData={ReferralAndFnFBannerData} />
              )}

              {process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR || process.env.NEXT_PUBLIC_DEFAULT_SITES ? <BrandMenu topBrands={topBrands} /> : null}

            </div >
          </div >
        </div >
      </div >
      <div className="brands-desc-wrapper" id="brand-description">
        <div className="container py-5">
          <div className="brand-description" ref={brandDescriptionRef}>
            {/* <p className="cms-description" dangerouslySetInnerHTML={{ __html: brandDescription }} /> */}
            <p className="cms-description">
              <DangerousHTML html={brandDescription} />
            </p>
          </div>
        </div>
      </div>
      {
        brandFaqs.length ? (
          <div className="faq-container">
            <h2 className="bold text-center">FAQ</h2>
            <div className="faq-wrapper container">
              {brandFaqs.map((faq, key) => {
                return (
                  <div className="faq-qna" key={key}>
                    <div className="faq-quest">
                      <p>{faq.question}</p>
                    </div>
                    <div className="faq-ans">
                      <DangerousHTML html={faq.answer} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null
      }
      {/* <div className="container">
        <div className="all-category py-4">
          <h2 className="semi-bold h3 b-title">Shop By All Categories</h2>
          {fullCategoryList && <CategoryMenu fullCategoryList={fullCategoryList} />}
        </div>
      </div> */}

      {isNewHomePageApplicable && false ? <FixedBottomBar
        scrollDirectionTop={scrollDirectionTop}
        tab={tab}
        setTab={setTab}
        hideFreightLimit={hideFreightLimit}
        unifiedMenu={unifiedMenu}
        displayFreightBanner={displayFreightBanner}
        asapEnabled={asapEnabled}
        scheduleEnabled={scheduleEnabled}
        asapProductsCount={asapCount}
        scheduledProductsCount={scheduleCount}
        hideFilters={hideFilters}
        filters={filters}
        toggleFilterPopup={toggleFilterPopup}
        filterApplied={filterApplied}
        setDisplayFreightBanner={setDisplayFreightBanner}
        initialDeliveryAddressDetails={initialDeliveryAddressDetails}

      /> : null}
    </div >
  );
};

const { brandRedirects: redirects, brandNoIndex } = grassdoorRedirects;

async function getServerSidePropsFunction({ req, res, query: { slug, tab } }) {
  const redirect = redirects[slug];
  const index = oldBrandSlug.indexOf(slug);
  if (tab !== 'asap' && tab !== 'schedule' && tab !== undefined) {
    return {
      redirect: {
        destination: `/brands/${slug}?tab=asap`,
        permanent: false
      }
    };
  }
  const { brandRedirects: bentoBrandRedirects } = bentoRedirects;
  if (process.env.NEXT_PUBLIC_APP === WEBSITES.BENTO && bentoBrandRedirects[slug]) {
    return {
      redirect: {
        destination: `/brands/${bentoBrandRedirects[slug]}`
      }
    };
  }

  if (process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR && redirect) {
    res.writeHead(301, { location: `${redirect}` });
    res.end();
  } else if (slug && index !== -1) {
    res.writeHead(301, { location: `/brands/${newBrandSlug[index]}` });
    res.end();
  }

  const cookies = new Cookies(req, res);
  const zipcode = cookies.get(COOKIE_VARIABLES.zipcode) || DEFAULT_ZIPCODE;
  const latitude = cookies.get(COOKIE_VARIABLES.latitude) || DEFAULT_LOCATION.lat;
  const longitude = cookies.get(COOKIE_VARIABLES.longitude) || DEFAULT_LOCATION.lng;
  const placeId = cookies.get(COOKIE_VARIABLES.placeId) || '';
  const token = cookies.get(COOKIE_VARIABLES.token) || '';
  const host = req?.headers?.host === 'localhost:3000'
    ? process.env.NEXT_PUBLIC_FALLBACK_API_URL
    : req?.headers?.host;
  const promiseArray = [];

  let authorizationToken = {};
  if (token) {
    authorizationToken = {
      authorization: `Bearer ${token}`
    };
  }

  const headers = { 'x-origin': host, 'saas-domain': host, zc: zipcode, placeId, lat: latitude, lng: longitude, ...authorizationToken };
  const deliveryResponse = await fetchServerResponse({
    url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/pre_fetch/delivery_details/${zipcode}`,
    method: 'GET',
    headers,
  });
  const { asap_driver_id } = deliveryResponse.data || {};

  let url = `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/brands/${slug}/${zipcode}`;
  if (
    process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR ||
    process.env.NEXT_PUBLIC_DEFAULT_SITES
  ) {
    url += '?sort_key=deals_first&order=asc&group_categories=false';
  } else {
    url += '?group_categories=true';
  }
  if (asap_driver_id) {
    url += `&asap_driver_id=${asap_driver_id}`
  }

  promiseArray.push(
    axios({
      url,
      method: 'GET',
      hideError: true,
      headers: {
        'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host,
        ...authorizationToken
      },
    })
  );
  promiseArray.push(
    axios({
      url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/categories/all_categories/'90001'?brand_slug=${slug}`,
      method: 'GET',
      headers: { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }
    })
  );
  promiseArray.push(
    axios({
      url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/cms/carousel_details`,
      method: 'GET',
      headers: { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }
    })
  );
  promiseArray.push(
    axios({
      url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/pre_fetch/delivery_details/${zipcode}`,
      method: 'GET',
      headers: { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }
    })
  );
  promiseArray.push(
    axios({
      url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/pre_fetch/logo`,
      method: 'GET',
      headers: { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }
    })
  );
  promiseArray.push(
    axios({
      url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/brands/top_brands`,
      method: 'GET',
      headers: { 'x-origin': host, zc: zipcode, placeId, lat: latitude, lng: longitude, 'saas-domain': host, }
    })
  );

  try {
    const response = await Promise.all(promiseArray);
    const brandResponse = response[0];
    const filterResponse = response[1];
    const deliverDetailsResponse = response[3];
    const fullCategoriesListResponse = response[4];
    const topBrandsResponse = response[5];
    const brandData = get(brandResponse, 'data.data', {}) || {};

    const fullShopCategories = categoriesHelper(get(filterResponse, 'data.full_shop_categories', []));
    const productStrainTypes = categoriesHelper(get(filterResponse, 'data.product_strain_types', []));
    const deviceTypes = get(filterResponse, 'data.device_types', []);

    const filterList = generateFilters({ fullShopCategories, productStrainTypes, deviceTypes });

    let noIndex = false;

    const asapEnabled = get(deliverDetailsResponse, 'data.asapEnabled', undefined);
    const scheduleEnabled = get(deliverDetailsResponse, 'data.scheduleEnabled', undefined);

    if (tab !== SCHEDULE && (!brandData.asap_categories || !brandData.asap_categories.length || !asapEnabled)) {
      return {
        redirect: {
          destination: `/brands/${slug}?tab=${SCHEDULE}`,
          permanent: false
        }
      };
    }
    if (tab !== ASAP && !scheduleEnabled) {
      return {
        redirect: {
          destination: `/brands/${slug}?tab=${ASAP}`,
          permanent: false
        }
      };
    }

    const asapProductCount = brandData.asap_categories.reduce((total, category) => {
      if (process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR || process.env.NEXT_PUBLIC_DEFAULT_SITES) {
        if (category && category.length) {
          return total + category.length;
        }
      } else {
        if (category && category.products && category.products.length) {
          return total + category.products.length;
        }
      }
      return total;
    }, 0);

    const scheduleProductCount = brandData.schedule_categories.reduce((total, category) => {
      if (process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR || process.env.NEXT_PUBLIC_DEFAULT_SITES) {
        if (category && category.length) {
          return total + category.length;
        }
      } else {
        if (category && category.products && category.products.length) {
          return total + category.products.length;
        }
      }
      return total;
    }, 0);

    if (tab == SCHEDULE) {
      if (scheduleProductCount < 2) {
        noIndex = false;
      }
    } else if (asapProductCount < 2) {
      noIndex = false;
    }
    const overrideBrandArray = [
      'Phinest',
      'field-extracts',
      'pearl-pharma',
      'space-coyote',
      'west-coast-sunrise',
      'st-ides',
      'vital-solutions',
      'island',
      'jefferson-soul',
      'mx'
    ];
    if (overrideBrandArray.includes(slug)) {
      noIndex = false;
    }

    if (process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR && brandNoIndex.includes(slug)) {
      noIndex = true;
    }

    const bannerResponse = response[2];
    const seoData = get(bannerResponse, 'data.data', []);
    const bannerData = seoData && seoData.banner_images ? seoData.banner_images : {};
    const fullCategoriesList = get(fullCategoriesListResponse, 'data', []);
    const initialTopBrandsResponse = topBrandsResponse?.data?.data || [];
    return {
      props: {
        brandData,
        filterList,
        host,
        bannerData,
        noIndex,
        id: String(slug),
        key: String(slug),
        fullCategoriesList,
        topBrands: initialTopBrandsResponse
      } // will be passed to the page component as props
    };
  } catch (error) {
    res.statusCode = 404;
    return { props: { error: 404, id: String(slug), key: String(slug) } };
  }
}
export const getServerSideProps = withConfig(getServerSidePropsFunction)
export default pageDisable(Brand);
